module.exports = new __parcel__URL__("linear-logomark.bd6d7925.svg").toString();